import type { RefObject } from 'react'
import { PanelLeftClose, PanelLeftOpen } from 'lucide-react'
import { sidebarShortcutLabel } from '@/lib/sidebar-size'
import { isMacPlatform } from '@/hooks/use-sidebar-layout'

interface SidebarToggleProps {
  rail: boolean
  toggleKey: RefObject<HTMLButtonElement | null>
  onToggle: () => void
}

/**
 * The key that folds the sidebar to its icon rail and back (Bilanss SidebarToggle). It says which way it goes, and
 * its shortcut. Its tooltip hangs below it in the full sidebar and stands beside it in the rail.
 */
export function SidebarToggle({ rail, toggleKey, onToggle }: SidebarToggleProps) {
  const shortcut = sidebarShortcutLabel(isMacPlatform())
  const label = rail ? 'Expand sidebar' : 'Collapse sidebar'
  const Icon = rail ? PanelLeftOpen : PanelLeftClose

  return (
    <button
      ref={toggleKey}
      type="button"
      className="sidebar-toggle key key-lite"
      aria-controls="app-sidebar"
      aria-expanded={!rail}
      aria-label={label}
      aria-keyshortcuts={shortcut.aria}
      data-tip={label}
      data-tip-keys={shortcut.shown}
      data-tip-place={rail ? undefined : 'below'}
      onClick={onToggle}
    >
      <Icon size={16} aria-hidden="true" />
    </button>
  )
}
